import { render, staticRenderFns } from "./SinisterAppraisersList.vue?vue&type=template&id=f53bccac"
import script from "./SinisterAppraisersList.vue?vue&type=script&lang=ts"
export * from "./SinisterAppraisersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports